import { render, staticRenderFns } from "./View.vue?vue&type=template&id=e0a70192"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"
import style0 from "./View.vue?vue&type=style&index=0&id=e0a70192&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0a70192')) {
      api.createRecord('e0a70192', component.options)
    } else {
      api.reload('e0a70192', component.options)
    }
    module.hot.accept("./View.vue?vue&type=template&id=e0a70192", function () {
      api.rerender('e0a70192', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Notifications/View.vue"
export default component.exports